import { createContext, useContext } from "react";

export interface UserAgent {
    isMobile: boolean;
    isTablet: boolean;
    isDesktop: boolean;
}

export const UserAgentContext = createContext<UserAgent | undefined>(undefined);

export const useUserAgent = () => {
    const context = useContext(UserAgentContext);
    if (!context) {
        // Return default values during SSR if context is not available
        return {
            isMobile: false,
            isTablet: false,
            isDesktop: true,
        };
    }
    return context;
};
